import { render, staticRenderFns } from "./DateSelect.vue?vue&type=template&id=476895f0&scoped=true&"
import script from "./DateSelect.vue?vue&type=script&lang=js&"
export * from "./DateSelect.vue?vue&type=script&lang=js&"
import style0 from "./DateSelect.vue?vue&type=style&index=0&id=476895f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476895f0",
  null
  
)

/* custom blocks */
import block0 from "./DateSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports